/**
 * Brand Configuration
 * Single source of truth for all brand assets and naming
 */

export const BRAND_NAME = "Trap Comix";
export const BRAND_TAGLINE = "Where Comics Come Alive";

// Logo assets
export const LOGO_SRC = "/brand/trapcomix-logo.png";
export const LOGO_ALT = "Trap Comix logo";
export const LOGO_SQUARE_SRC = "/brand/trapcomix-square.png";
export const LOGO_OG_SRC = "/brand/trapcomix-og.png";

// Favicon assets
export const FAVICON_SRC = "/favicon.ico";
export const FAVICON_32_SRC = "/favicon-32x32.png";
export const FAVICON_16_SRC = "/favicon-16x16.png";
export const APPLE_TOUCH_ICON_SRC = "/apple-touch-icon.png";

// SEO defaults
export const SEO = {
  siteName: BRAND_NAME,
  title: `${BRAND_NAME} - ${BRAND_TAGLINE}`,
  description: "Discover and read amazing webcomics, novels, and artwork from talented creators.",
  ogImage: LOGO_OG_SRC,
  twitterImage: LOGO_OG_SRC,
  themeColor: "#f97316", // Orange-500
};

// Logo component helper styles
export const LOGO_STYLES = {
  navbar: "h-8 md:h-10 w-auto object-contain",
  navbarMobile: "h-7 w-auto object-contain",
  footer: "h-8 w-auto object-contain",
  auth: "h-16 w-auto object-contain mx-auto",
  splash: "h-24 w-auto object-contain",
};

export default {
  BRAND_NAME,
  BRAND_TAGLINE,
  LOGO_SRC,
  LOGO_ALT,
  LOGO_SQUARE_SRC,
  LOGO_OG_SRC,
  SEO,
  LOGO_STYLES,
};
